<script setup lang="ts">
import { mdiAlert, mdiAlertCircle, mdiInformation, mdiArrowLeftCircle } from '@mdi/js'
import { EventFlag } from '@/api/models/definitions'

import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  status?: string | EventFlag
  selected?: boolean
}

defineProps<Props>()
</script>

<template>
  <div v-if="status">
    <SvgIcon
      v-if="status === EventFlag.Information"
      :path="mdiInformation"
      class="fill-success h-4 w-4"
    />
    <SvgIcon v-if="status === EventFlag.Warning" :path="mdiAlert" class="fill-warning h-4 w-4" />
    <SvgIcon v-if="status === EventFlag.Error" :path="mdiAlertCircle" class="fill-error h-4 w-4" />
    <SvgIcon
      v-if="status === EventFlag.Returned"
      :path="mdiArrowLeftCircle"
      class="h-4 w-4"
      :class="selected ? 'fill-white' : 'fill-gray-700'"
    />
  </div>
</template>
